/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * 31 Milk St # 960789 Boston, MA 02196 USA.
 *
 * Copyright (c) 2025 (original work) Open Assessment Technologies SA
 */
import { Userpilot } from 'userpilot';
import env from '@/config/env';
import { user } from '@/store/auth';
import {
    ROLE_ADMIN,
    ROLE_BACKOFFICE,
    ROLE_BATTERY,
    ROLE_CONTENT_CREATOR,
    ROLE_DASHBOARD_VIEWER,
    ROLE_DATA_EXPLORER,
    ROLE_GRADER,
    ROLE_GROUP_CREATOR,
    ROLE_GROUP_MANAGER,
    ROLE_OFFLINE_UPLOADER,
    ROLE_ONLINE_UPLOADER,
    ROLE_REVIEW_GRADER
} from '@/core/utils/consts';
import { configurationStore } from '@/store/tenantConfiguration';
const PROCESS_ENV = env('NODE_ENV');
const USERPILOT_TOKEN = env('USERPILOT_TOKEN');
const GA_TAG = env('GA_TAG');

const ROLES_WHITELIST = [
    ROLE_ADMIN,
    ROLE_BACKOFFICE,
    ROLE_BATTERY,
    ROLE_CONTENT_CREATOR,
    ROLE_GRADER,
    ROLE_GROUP_CREATOR,
    ROLE_GROUP_MANAGER,
    ROLE_OFFLINE_UPLOADER,
    ROLE_ONLINE_UPLOADER,
    ROLE_DASHBOARD_VIEWER,
    ROLE_REVIEW_GRADER,
    ROLE_DATA_EXPLORER
];

function insertGAScript() {
    // Create the async script tag
    const scriptTag = document.createElement('script');
    scriptTag.async = true;
    scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TAG}`;
    document.head.appendChild(scriptTag);

    // Create the inline config script
    const inlineScript = document.createElement('script');
    inlineScript.text = `
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', '${GA_TAG}', {
            environment: '${PROCESS_ENV === 'production' ? 'Production' : 'Internal'}'
        });
    `;
    document.head.appendChild(inlineScript);
}

/**
 * Initialize analytics for current user
 */
export function initialize() {
    const currentUser = user.get();
    const userpilotToken = configurationStore.getUserpilotToken() || USERPILOT_TOKEN;
    if (ROLES_WHITELIST.some(item => currentUser.roles.includes(item)) && userpilotToken) {
        const params = {
            name: currentUser.name,
            login: currentUser.userId,
            email: currentUser.email,
            roles: currentUser.roles,
            company: {
                id: currentUser.tenantId
            }
        };
        Userpilot.initialize(userpilotToken);
        Userpilot.identify(`${currentUser.tenantId}|${currentUser.userId}`, params);
    }

    if (GA_TAG) {
        insertGAScript();
    }
}
